var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"swiper",staticClass:"swiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.customPosts),function(post,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('PostItem',{key:index,attrs:{"post":post,"currentSlideId":_vm.currentSlideId}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }